import {logPlugin} from "@babel/preset-env/lib/debug";

export const observer = new IntersectionObserver(function (entries, observer) {
    var buttonWrapper = document.getElementById("scrollButtonWrapper");

    entries.forEach((entry) => {
        if ( entry.isIntersecting ) {
            buttonWrapper.style.display = "none";
        }

        if (!entry.isIntersecting) {
            buttonWrapper.style.display = "block";
        }
    }
    )});
